import { Skeleton } from '@sravni/react-design-system/lib/Skeleton';
import { Space } from '@sravni/react-design-system/lib/Space';
import cn from 'classnames';

import { AdaptiveCard } from 'shared/ui/AdaptiveCard';

import styles from './FilterSkeleton.module.scss';

type FilterSkeletonProps = {
  className?: string;
};

export const FilterSkeleton = ({ className }: FilterSkeletonProps) => {
  return (
    <Skeleton className={className}>
      <AdaptiveCard
        desktopSize={24}
        mobileSize={16}
        className={cn(styles.card)}
      >
        <Space
          align="center"
          size={4}
        >
          <Space
            direction="vertical"
            size={8}
          >
            <Skeleton.Paragraph
              width={60}
              className={styles.title}
            />
            <Skeleton.Paragraph
              width={70}
              className={styles.subtitle}
            />
          </Space>
          <Space className="h-w-mc">
            <Skeleton.Avatar className={styles.icon} />
          </Space>
        </Space>
      </AdaptiveCard>
    </Skeleton>
  );
};
